import { render, staticRenderFns } from "./CollectionList.vue?vue&type=template&id=775d8060&"
import script from "./CollectionList.vue?vue&type=script&lang=js&"
export * from "./CollectionList.vue?vue&type=script&lang=js&"
import style0 from "./CollectionList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports